import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { LlmSanitizerConfig, fixInternalLinkTargets } from '../LlmSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
const BACKTICK_REGEX = /`([^`]+)`/g;
const replaceBackticksWithCodeBlocks = text => text.replace(BACKTICK_REGEX, '<code class="inline-code-snippet" role="code">$1</code>');
const Markdown = ({
  html
}) => {
  const portalId = useMemo(() => PortalIdParser.get(), []);
  const sanitizedHtml = useMemo(() => {
    const cleaned = sanitize(html, LlmSanitizerConfig);
    return fixInternalLinkTargets(cleaned, portalId);
  }, [html, portalId]);
  const decoratedHtml = useMemo(() => replaceBackticksWithCodeBlocks(sanitizedHtml), [sanitizedHtml]);
  // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
  return /*#__PURE__*/_jsx("span", {
    dangerouslySetInnerHTML: {
      __html: decoratedHtml
    }
  });
};
export default Markdown;